import * as fromDatatype from '../datatype-library/index';

export interface bl_b2b_ipo_xdo_igrn_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_2: fromDatatype.VarcharDatatypeInterface;
    client_doc_3: fromDatatype.VarcharDatatypeInterface;
    client_doc_4: fromDatatype.VarcharDatatypeInterface;
    client_doc_5: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    gen_doc_created_date: fromDatatype.TimestampTzDatatypeInterface;
    gen_doc_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    last_processed_time: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_b2b_ipo_xdo_igrn_queue_RowClass implements bl_b2b_ipo_xdo_igrn_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_2: fromDatatype.VarcharDatatypeInterface;
    client_doc_3: fromDatatype.VarcharDatatypeInterface;
    client_doc_4: fromDatatype.VarcharDatatypeInterface;
    client_doc_5: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    gen_doc_created_date: fromDatatype.TimestampTzDatatypeInterface;
    gen_doc_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    last_processed_time: fromDatatype.TimestampTzDatatypeInterface;
}
